import { render, staticRenderFns } from "./BlockListIframe.vue?vue&type=template&id=7c043b4e&"
import script from "./BlockListIframe.vue?vue&type=script&lang=js&"
export * from "./BlockListIframe.vue?vue&type=script&lang=js&"
import style0 from "./BlockListIframe.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports